// LogDisplayComponentV2.tsx
import React from 'react';
import styled from 'styled-components';
import { Card, Typography, Button, Tooltip, Space, message } from 'antd';
import ReactJson from 'react-json-view';
import { CopyOutlined, DownloadOutlined } from '@ant-design/icons';

const { Text } = Typography;

const LogWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const LogCard = styled(Card)`
  background: #ffffff;
  border: 1px solid #e1e1e1;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
`;

const HeaderBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

const ActionButtons = styled(Space)`
  display: flex;
  align-items: center;
`;

interface LogDisplayComponentProps {
  logs: { id: string; timestamp: string; description: string;added_by?: string; }[];
}

const LogDisplayComponentV2: React.FC<LogDisplayComponentProps> = ({ logs }) => {
  const downloadJson = (json: object, filename: string) => {
    const blob = new Blob([JSON.stringify(json, null, 2)], { type: 'application/json' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${filename}.json`;
    link.click();
  };

  return (
    <LogWrapper>
      {logs.map((log) => {
        let parsed: any = null;
        let error = null;
        try {
          parsed = JSON.parse(log.description);
        } catch (err) {
          error = err;
        }

        return (
          <LogCard key={log.id}>
<HeaderBar>
  <div>
    <Text strong>{new Date(log.timestamp).toLocaleString()}</Text>
    <Text type="secondary" style={{ marginLeft: 8 }}>
      — from {log.added_by || "—"}
    </Text>
  </div>

  <ActionButtons size="middle">
    {!error && (
      <Tooltip title="Copy JSON">
        <Button
          icon={<CopyOutlined />}
          onClick={() => {
            navigator.clipboard
              .writeText(JSON.stringify(parsed, null, 2))
              .then(() => message.success("Copied to clipboard!"))
              .catch(() => message.error("Copy failed"));
          }}
        />
      </Tooltip>
    )}
    {!error && (
      <Tooltip title="Download JSON">
        <Button
          icon={<DownloadOutlined />}
          onClick={() => downloadJson(parsed, `log-${log.id}`)}
        />
      </Tooltip>
    )}
  </ActionButtons>
</HeaderBar>

            {error ? (
              <Text type="danger">❌ Invalid JSON format</Text>
            ) : (
              <ReactJson
                src={parsed}
                name={false}
                theme="rjv-default"
                enableClipboard={false}
                displayDataTypes={false}
                collapsed={2}
              />
            )}
          </LogCard>
        );
      })}
    </LogWrapper>
  );
};

export default LogDisplayComponentV2;
